import { styled } from '@mui/material/styles';
import { Link } from '@raisin/components-lib';
export const Background = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(5),
    backgroundColor: theme.palette.black10.main,
}));
export const Wrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(7, 0),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(5, 0),
        flexDirection: 'column',
    },
}));
export const InnerWrapper = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        marginBottom: theme.spacing(2.5),
    },
}));
export const StarsWrapper = styled('div')(({ theme }) => ({
    margin: `0 ${theme.spacing(7.5)}`,
    [theme.breakpoints.down('md')]: {
        margin: `${theme.spacing(3)} 0 0`,
    },
}));
export const StarsLink = styled(Link)(({ theme }) => ({
    display: 'flex',
    margin: `0 ${theme.spacing(2.5)} 0 0`,
    textDecoration: 'none',
}));
export const Stars = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2.5),
    '& > svg': {
        width: '100px',
        height: 'auto',
    },
}));
export const StarsText = styled('span')(() => ({
    fontWeight: 700,
}));
export const ReviewsText = styled('div')(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));
export const LogoLink = styled('a')(() => ({
    display: 'flex',
    alignItems: 'center',
}));
//# sourceMappingURL=styles.js.map